export default {
  occurrenceUnit: 'occurrence | occurrences',
};
